import * as React from "react"

const DefaultAway = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={124.417}
    height={195.739}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 2479 3899"
    {...props}
  >
    <path
      d="M126 3712c154 18 634 71 1108 71 614 0 999-49 1127-69V1243c-50-61-203-272-220-560-14-234 16-376 32-446-85-29-236-78-388-106-56 338-287 581-570 581-285 0-505-231-564-574-88 20-168 48-229 70-29 10-54 19-75 26-40 12-63 19-115 41 41 191 65 324 54 476-18 259-131 441-170 496l9 2466zM1656 180c-90 50-239 105-456 97-195-7-335-57-421-101 62 253 228 418 436 418 206 0 378-169 441-415z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M126 3712c154 18 634 71 1108 71 614 0 999-49 1127-69V1243c-50-61-203-272-220-560-14-234 16-376 32-446-85-29-236-78-388-106-56 338-287 581-570 581-285 0-505-231-564-574-88 20-168 48-229 70-29 10-54 19-75 26-40 12-63 19-115 41 41 191 65 324 54 476-18 259-131 441-170 496l9 2466zm1863-899h-326l-129-341H934l-124 341H490l581-1496h320l599 1496zm-554-593-208-554-202 554h410zm220-2039c-90 50-239 105-456 97-195-7-335-57-421-101 62 253 228 418 436 418 206 0 378-169 441-415zM637 21v-5l32-2 33-6 27-4 7 6 17-1c0 6 1 11 1 17 29 22 177 125 449 134 327 11 469-133 474-139l2-2v-9h8l10-10 30 4c212 28 436 106 521 136l5 2c56 19 43 76 34 118-14 63-44 195-30 417 18 295 203 504 205 506l15 17v2613l-47 9c-17 3-423 79-1197 79-580 0-1168-77-1174-78l-50-7-10-2608 13-16c1-2 139-180 158-449 11-149-15-277-62-490l-10-47 44-19c92-40 120-48 171-64 20-6 43-14 70-24 67-24 155-55 255-77z"
      style={{
        fill: "#252422",
        fillRule: "nonzero",
      }}
    />
  </svg>
);

export default DefaultAway;
